import { IChangeInProgressForStudentModule } from '../Interfaces/IChangeInProgressForStudentModule';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { setExamForStudentInProgressInitState } from './InitState';
import SHARING_ACTIONS from '../Actions/ActionTypes';

export const setExamForStudentInProgressReducer = (
  state: Array<IChangeInProgressForStudentModule> = setExamForStudentInProgressInitState,
  action: IAction<IChangeInProgressForStudentModule>
): Array<IChangeInProgressForStudentModule> => {
  switch (action.type) {
    case SHARING_ACTIONS.SET_EXAM_FOR_STUDENT_START:
      return [...state, action.payload];

    case SHARING_ACTIONS.SET_EXAM_FOR_STUDENT_FINISH:
      return [
        ...state.filter(
          (value) =>
            value.moduleNumber !== action.payload.moduleNumber &&
            value.studentId !== action.payload.studentId
        ),
      ];

    default:
      return state;
  }
};
